import React from 'react';
import {
  Box,
  Typography,
  CircularProgress as MuiCircularProgress,
  LinearProgress as MuiLinearProgress,
} from '@mui/material';
import type { LinearProgressProps, CircularProgressProps } from '@mui/material';

export const LinearProgress: React.FC<LinearProgressProps> = (props) =>
  props.label ? (
    <LinearProgressWithLabel {...props} />
  ) : (
    <MuiLinearProgress {...props} />
  );

export const LinearProgressWithLabel: React.FC<LinearProgressProps> = (
  props,
) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Box sx={{ width: '100%', mr: 1 }}>
      <MuiLinearProgress {...props} />
    </Box>
    <Box sx={{ minWidth: 35 }}>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {`${Math.round(props.value || 0)}%`}
      </Typography>
    </Box>
  </Box>
);

export const CircularProgress: React.FC<CircularProgressProps> = (props) =>
  props.label ? (
    <CircularProgressWithLabel {...props} />
  ) : (
    <MuiCircularProgress {...props} />
  );

export const CircularProgressWithLabel: React.FC<CircularProgressProps> = (
  props,
) => (
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    <MuiCircularProgress {...props} />
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="caption"
        component="div"
        sx={{ color: 'text.secondary' }}
      >
        {`${Math.round(props.value || 0)}%`}
      </Typography>
    </Box>
  </Box>
);
